export const EducationTypeValues = [
    'DEGREE',
    'COURSE',
    'SELF_TRAINING'
];
//# sourceMappingURL=education-type.js.map